import React from "react";
import {
  FileLayoutMaintenancePageContent,
  FileLayoutMaintenancePageStateProvider,
} from ".";

export const FileLayoutMaintenancePage = () => {
  return (
    <>
      <FileLayoutMaintenancePageStateProvider>
        <FileLayoutMaintenancePageContent></FileLayoutMaintenancePageContent>
      </FileLayoutMaintenancePageStateProvider>
    </>
  );
};
